// extracted by mini-css-extract-plugin
module.exports = {"arrows":"CouponDetailContent_arrows__euvuR"};